import React from 'react'
import PropTypes from 'prop-types'
import { Section } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'
import { H6, P } from '@PipelineDeals/shared-react-components'

const SimpleSection = ({ field, value, label }) => {
  const { cardMeta: { showOnlyFields, showEmptyFields } } = useBusinessCard()

  if (!showOnlyFields.includes(field)) return null
  if (!showEmptyFields && !value) return null
  if (String(value).trim() === '') return null

  return (
    <Section>
      <H6 title={label}>{label}</H6>
      <P>{value}</P>
    </Section>
  )
}

SimpleSection.propTypes = {
  field: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string
}

export default SimpleSection
